module.exports = __webpack_public_path__ + "static/media/jb-profile.a188ed5f.png";